import { useState } from 'react';
import { ClipboardCopy, Download, Check } from 'lucide-react';
import { useExport } from '../../hooks/use-export';
import { Button } from '../ui/Button';
import { useLanguageStore } from '../../stores/language-store';
import { t } from '../../i18n/translations';

export function ExportMenu() {
  const { copyToClipboard, downloadFile } = useExport();
  const [copied, setCopied] = useState(false);
  const language = useLanguageStore((s) => s.language);

  const handleCopy = async () => {
    try {
      await copyToClipboard();
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch {
      // Clipboard may fail in non-secure contexts
    }
  };

  return (
    <div className="flex items-center gap-1">
      <Button variant="ghost" size="sm" onClick={handleCopy} title={t(language, 'copyHtml')}>
        {copied ? <Check size={14} /> : <ClipboardCopy size={14} />}
        <span>{copied ? t(language, 'copied') : t(language, 'copy')}</span>
      </Button>
      <Button variant="ghost" size="sm" onClick={downloadFile} title={t(language, 'downloadHtml')}>
        <Download size={14} />
        <span>{t(language, 'download')}</span>
      </Button>
    </div>
  );
}
